@let apiResponse = data();
@if (apiResponse) {
  <p-table
    [value]="apiResponse.data"
    [loading]="opkraevningsListerService.datasource.isLoading()"
    [showGridlines]="true"
    [scrollable]="true"
    scrollHeight="flex"
    stripedRows
    class="p-datatable-sm lp-table"
    selectionMode="single"
    [metaKeySelection]="true"
    (onRowSelect)="onRowSelect($event)"
    dataKey="id"
    [lazy]="true"
    [lazyLoadOnInit]="false"
    (onLazyLoad)="onLazyLoad($event)"
    sortField="fornavn"
    [sortOrder]="1"
    [paginator]="true"
    [rows]="100"
    [totalRecords]="apiResponse.totalRowCount"
    [showJumpToPageDropdown]="true"
    letKeepScrollPosition>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="regnr">
          Regnr
          <p-sortIcon field="regnr" />
        </th>
        <th pSortableColumn="koerselsNr">
          Kørsel nr.
          <p-sortIcon field="koerselsNr" />
        </th>
        <th pSortableColumn="oprettelsesDato">
          Oprettet
          <p-sortIcon field="oprettelsesDato" />
        </th>
        <th pSortableColumn="afsendt">
          Afsendt
          <p-sortIcon field="afsendt" />
        </th>
        <th>Regneark</th>
      </tr>
    </ng-template>
    <ng-template [appTableRow]="apiResponse.data" pTemplate="body" let-item>
      <tr [pSelectableRow]="item" class="cursor-pointer">
        <td>{{ item.pengeinstitut.regnr }}</td>
        <td>{{ item.koerselsNr }}</td>
        <td class="numbers">
          {{ item.oprettelseDato | date: 'dd-MM-yyyy HH:mm' }}
        </td>
        <td class="numbers">{{ item.afsendt | date: 'dd-MM-yyyy HH:mm' }}</td>
        <td>
          <i
            class="pi pi-file-excel cursor-pointer"
            (click)="exportData($event, item.id)"></i>
        </td>
      </tr>
    </ng-template>
  </p-table>
}
